import React from 'react';

import {ReviewStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import * as ReviewUtil from 'notebook/reviews/ReviewUtil';

export const DocumentBanner = {
  Archived,
  ReadOnly,
  PreviousVersion,
  ReviewLocked,
  ExternalChangeLocked,
};

type DocumentType = 'entry' | 'protocol' | 'template' | 'sub-template';

function Archived({docType}: {docType: DocumentType}): JSX.Element {
  return <span>Editing disabled on archived {docType}.</span>;
}

function ReadOnly({docType}: {docType: DocumentType}): JSX.Element {
  return <span>Editing disabled on read-only {docType}.</span>;
}

function PreviousVersion({
  docType,
  isEvaluationPersisted,
  onNavigateToLatest,
}: {
  docType: DocumentType;
  isEvaluationPersisted: boolean;
  onNavigateToLatest?: () => void;
}): JSX.Element {
  return (
    <span>
      Editing disabled on previous versions.
      {!isEvaluationPersisted && (
        <>
          {' '}
          <>Formulas have been re-computed and may differ from original values in rare cases.</>
        </>
      )}
      {onNavigateToLatest && (
        <>
          {' '}
          <a onClick={onNavigateToLatest}>View the latest {docType} version.</a>
        </>
      )}
    </span>
  );
}

function ReviewLocked({status}: {status: ReviewStatus}): JSX.Element {
  return <span>{ReviewUtil.getEditWarning(status)}</span>;
}

function ExternalChangeLocked({isUnsaved}: {isUnsaved: boolean}): JSX.Element {
  return (
    <span>
      Editing disabled on previous versions.{' '}
      {isUnsaved ? 'Copy unsaved changes before refreshing.' : 'Refresh to edit latest version.'}
    </span>
  );
}
